import { render, staticRenderFns } from "./PermissionMap.vue?vue&type=template&id=c929249e&scoped=true"
import script from "./PermissionMap.vue?vue&type=script&lang=js"
export * from "./PermissionMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c929249e",
  null
  
)

export default component.exports